import { grey, red } from "@material-ui/core/colors";
import { createTheme } from "@material-ui/core/styles";

import colors from "./colors";
import muiOverrides from "./muiOverrides";
import rAOverrides from "./raOverrides";

const theme = createTheme({
  palette: {
    primary: {
      dark: colors.primary.dark,
      main: colors.primary.main,
      light: colors.primary.light,
      contrastText: grey[200],
    },
    secondary: {
      main: "#2d2d2d",
    },
    error: {
      main: red[300],
    },
  },
  sidebar: {
    width: 250,
  },
  overrides: {
    ...muiOverrides,
    ...rAOverrides,
  },
} as any);

export default theme;
